<div>
  <prime-loading-spinner></prime-loading-spinner>
</div>
